import { MY_ADS_PATHS } from './ProfileNav.constants';

export function isProfileNavItemActive(pathname: string, href: string) {
  const [hrefPath] = href.split('#');

  if (hrefPath === '/profile/published') {
    return MY_ADS_PATHS.includes(pathname);
  }

  if (hrefPath === '/profile/business') {
    return pathname.startsWith('/profile/business');
  }

  return pathname === hrefPath;
}
